import script from "./NationalIdNumberInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./NationalIdNumberInput.vue?vue&type=script&setup=true&lang=ts"

import "@/assets/css/baseformfield.scss?vue&type=style&index=0&id=72558d9e&scoped=true&lang=scss&external"
import "./NationalIdNumberInput.vue?vue&type=style&index=1&id=72558d9e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72558d9e"]])

export default __exports__